<template>
  <g >
    <path :d=path :stroke=color2 :fill-opacity=fill_opacity :stroke-opacity=str_opacity :fill=color :stroke-width="swid" />
  </g>

</template>

<script>

import * as d3 from 'd3'

import {mapGetters, mapState} from 'vuex'

export default {
  name: 'DataConnection',
  props: ['link'],
  data () {
    return {
      over:false
    }
  },
  computed: {
    ...mapState(['value_scale','global_scale_x','global_scale_y','stroke_width','up_down','loss_color','energy_services_color','mousepos','column_separation','node_thickness']),
    ...mapGetters(['node_color']),
    src_object_container(){
      return this.link.source.parent
    },
    tgt_object_container(){
      return this.link.target.parent
    },
    src_object(){
      return this.link.source
    },
    tgt_object(){
      return this.link.target
    },
    fill_opacity(){
      if(this.irrelevant)
        return .01
      if(this.src_object.column < 3)
        return .05
      if(this.link.is_loss  || this.tgt_object.name.includes('services'))
        return .1
      return this.link.value*1e-1+.1
    },
    str_opacity(){
      if(this.irrelevant)
        return .05
      if(this.link.is_loss || this.tgt_object.name.includes('services'))
        return .2
      return this.link.value<1.?.3:.9
    },
    swid(){
      return this.stroke_width//+((this.src_object.column < 3)?1:0)
    },
    color(){
      //TODO: this should use a common function with datanode
      if(this.tgt_object.name.includes('*energy services*'))
        return d3.color(this.energy_services_color)
      if(this.link.is_loss)
        return d3.color(this.loss_color)
      return this.node_color(this.src_object)
    },
    color2(){
      return this.color.darker(.6)
    },
    irrelevant(){
      if (this.$store.state.up_down)
        return !this.up_or_down
      else
        return !this.searched
    },
    display_value(){
      return this.link.value*this.value_scale*this.global_scale_y
    },
    searched(){
      if (!this.$store.state.search_term) return true
      return this.link.target.is_searched && this.link.source.is_searched
    },
    up_or_down(){
      var c = this.$store.state.up_down
      if (!c) return -1
      if (this.src_object.is_updown && this.tgt_object.is_updown) return 1
      return 0
    },
    src_x() {
      return this.column_separation*this.src_object.column*this.global_scale_x
    },
    tgt_x() {
      return this.column_separation*this.tgt_object.column*this.global_scale_x
    },

    bumpsrc(){
      var ydist = this.src_object_container.y_position*this.global_scale_y-this.mousepos.y
      var xdist = this.src_x-this.mousepos.x
      if(xdist > 100) return 0
      var dist=  xdist*xdist + ydist*ydist
      var bump = 0
      var limit=150000

      if(dist < limit){
        bump = 1./Math.max(dist,1e-8)
      }
      return bump
    },
    bumptgt(){
      var ydist = this.tgt_object_container.y_position*this.global_scale_y-this.mousepos.y
      var xdist = this.tgt_x-this.mousepos.x
      if(xdist > 100) return 0
      var dist=  xdist*xdist + ydist*ydist
      var bump = 0
      var limit=150000
      if(dist < limit){
        bump = 1./Math.max(dist,1e-8)
      }
      return bump
    },
    path() {

      var curvature = .5

      //find y of potential aggregate node / parent
      var srcy = (this.src_object_container.y_position + this.src_object_container.relative_y_positions()[this.src_object.index]*this.value_scale)*this.global_scale_y
      var tgty = (this.tgt_object_container.y_position + this.tgt_object_container.relative_y_positions()[this.tgt_object.index]*this.value_scale)*this.global_scale_y
      var srcs = this.src_object.source_links
      var idx = srcs.indexOf(this.link)

      //find my index into the INDIVIDUAL node and adjust my position as needed
      if (idx > 0){
        srcy+=d3.sum(srcs.slice(0,idx),(l)=>{return l.value*this.value_scale*this.global_scale_y})
      }

      var tgts = this.tgt_object.target_links
      idx = tgts.indexOf(this.link)
      if (idx > 0){
        tgty+=d3.sum(tgts.slice(0,idx),(l)=>{return l.value*this.value_scale*this.global_scale_y})
      }


      var srcx= ((this.column_separation*this.src_object.column)+this.node_thickness)*this.global_scale_x,
          tgtx= (this.column_separation*this.tgt_object.column)*this.global_scale_x



      var x0 = srcx.toFixed(1),
          x1 = tgtx.toFixed(1),
          xi = d3.interpolateNumber(x0, x1),
          x2 = xi(curvature).toFixed(1),
          x3 = xi(1 - curvature).toFixed(1),
          y0top = srcy,
          y1top = tgty,
          y0bottom = (srcy + this.display_value),
          y1bottom = (tgty + this.display_value)



      var out= "M" + x0 + "," + (y0top+(y0bottom-y0top)*.5)
           + "C" + x2 + "," + (y0top+(y0bottom-y0top)*.5)
           + " " + x3 + "," + (y1top+(y1bottom-y1top)*.5)
          + " " + x1 + "," + (y1top+(y1bottom-y1top)*.5)
      //return out



      if (0){
        var out= "M" + x0 + "," + y0top
            + "L" + x2 + "," + y0top
            + "L" + x3 + "," + y1top
            + "L" + x1 + "," + y1top
            + "L" + x1 + "," + y1bottom
            + "L" + x3 + "," + y1bottom
            + "L" + x2 + "," + y0bottom
            + "L" + x0 + "," + y0bottom
            + " L" + x0 + "," + y0top
        ;
      }else{
        var out= "M" + x0 + "," + y0top
            + "C" + x2 + "," + y0top
            + " " + x3 + "," + y1top
            + " " + x1 + "," + y1top
            + "L" + x1 + "," + y1bottom
            + "C" + x3 + "," + y1bottom
            + " " + x2 + "," + y0bottom
            + " " + x0 + "," + y0bottom
            + " L" + x0 + "," + y0top
        ;
      }
      return out
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DataConnection.vue